import { Box } from '@material-ui/core'
import styled from 'styled-components'

export const StyledMentionable = styled(Box)`
  && {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 1rem;
  }
`

export const StyledTaggable = styled(Box)`
  && {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0.5rem;
  }
`

export const StyledMentionsList = styled(Box)`
  overflow-y: auto;

  ::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const StyledEllipsisBox = styled(Box)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`